<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              cropwidth="205"
              cropheight="225"
              :key="currentImage"
              @stepper="imageCropper"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <div v-else class="add-product-page">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <v-icon class="page-title-icon">mdi-package-variant-closed</v-icon>
          <div>
            <h1 class="page-title">Edit Product</h1>
          </div>
        </div>
      </div>

      <!-- Form Body -->
      <div class="form-body">
        <v-form ref="profileForm" v-model="valid" lazy-validation>
          <v-row>
            <!-- LEFT COLUMN -->
            <v-col cols="12" lg="8" class="form-left-col">
              
              <!-- 01 Basic Information -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">01</span>
                  <div>
                    <h2 class="section-title">Basic Information</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <div class="field-group">
                        <label class="field-label">Product Name</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="productname"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Product Name"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div class="field-group">
                        <label class="field-label">Product Cost</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="price"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Product Cost"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <div class="field-group">
                        <label class="field-label">Main Category</label>
                        <v-select
                          dense
                          v-model="mainCategory"
                          outlined hide-details
                          color="#4CAF50"
                          placeholder="MainCategory"
                          :items="mainCategoryArray"
                          item-text="name"
                          item-value="_id"
                          readonly
                          class="modern-input"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <div class="field-group">
                        <label class="field-label">Category</label>
                        <v-select
                          dense multiple
                          v-model="category"
                          outlined hide-details
                          color="#4CAF50"
                          placeholder="Category"
                          :items="categoryArray"
                          item-text="name"
                          item-value="_id"
                          class="modern-input"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <div class="field-group">
                        <label class="field-label">Subcategory</label>
                        <v-select
                          dense multiple
                          v-model="subcategory"
                          outlined hide-details
                          color="#4CAF50"
                          placeholder="Subcategory"
                          :items="subcategoryArray"
                          item-text="name"
                          item-value="_id"
                          class="modern-input"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <div class="field-group">
                        <label class="field-label">YouTube Link</label>
                        <v-text-field
                          v-model="link"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="YouTube Link"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <div class="field-group">
                        <label class="field-label">Description</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="description"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Description"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <div class="field-group">
                        <label class="field-label">Specifications of the Product</label>
                        <div id="app" style="background: white; border: 1px solid #dde3ea; border-radius: 8px; overflow: hidden;">
                          <vue-editor v-model="specifications"></vue-editor>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- 02 Inventory & Pricing -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">02</span>
                  <div>
                    <h2 class="section-title">Inventory &amp; Pricing</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Stock Quantity</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="quantity"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Stock Quantity"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Minimum Order Quantity</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="minimumOrderQuantity"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Minimum Order Quantity"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Maximum Order Quantity</label>
                        <v-text-field
                          v-model="maxOrderQuantity"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Maximum Order Quantity"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div class="field-group">
                        <label class="field-label">Offer</label>
                        <v-text-field
                          v-model="offer"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Offer"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div class="field-group">
                        <label class="field-label">Offer Price</label>
                        <v-text-field
                          v-model="offerPrice"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Offer Price"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- 03 Shipping & Tax -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">03</span>
                  <div>
                    <h2 class="section-title">Shipping &amp; Tax</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <div class="field-group">
                        <label class="field-label">Packing Charge</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="packingCharge"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Packing Charge"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="field-group">
                        <label class="field-label">Delivery Inside Kerala</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="deliveryChargeInsideKerala"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Delivery Charge"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="field-group">
                        <label class="field-label">Delivery Outside Kerala</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="deliveryChargeOutsideKerala"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Delivery Charge"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="field-group">
                        <label class="field-label">Tax</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="tax"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Tax"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- Submit (mobile / tablet only) -->
              <div class="submit-area-mobile hidden-lg-and-up">
                <v-row class="mt-2 pb-6">
                  <v-col cols="12" sm="6">
                    <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;">Cancel</v-btn>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-btn 
                      block large dark depressed 
                      color="#4CAF50" 
                      class="submit-btn text-capitalize" 
                      :ripple="false" 
                      :disabled="!valid"
                      @click="validate()">
                      <v-icon left>mdi-check-circle</v-icon>
                      Update Product
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

            </v-col>

            <!-- RIGHT COLUMN: Media Panel -->
            <v-col cols="12" lg="4" class="form-right-col">
              <div class="image-section sticky-panel">

                <div class="image-section-header">
                  <v-icon color="#4CAF50" class="mr-2">mdi-image-multiple</v-icon>
                  <span class="image-section-title">Product Images</span>
                </div>
                
                <div class="section-body px-0">
                  <v-layout wrap>
                    <v-flex md12 lg12>
                      <v-card flat tile outlined style="border-radius: 8px; border-color: #e8ecf0; background: #fafbfc;">
                        <v-layout wrap class="pa-2">
                          <v-flex
                            v-for="(item, i) in user.photos"
                            :key="'photo'+i"
                            xs4 sm3 md4 lg4
                            px-2 py-2
                          >
                            <v-badge small overlap avatar color="#FF1313">
                              <template v-slot:badge>
                                <v-avatar>
                                  <v-icon small @click="removePhotos(i)" style="cursor: pointer;">mdi-close</v-icon>
                                </v-avatar>
                              </template>
                              <div style="background: white; border-radius: 6px; border: 1px solid #dde3ea; padding: 4px; display: flex; align-items: center; justify-content: center; height: 60px;">
                                <v-img
                                  v-if="item"
                                  :src="mediaUURL + item"
                                  height="44px"
                                  width="44px"
                                  contain
                                >
                                </v-img>
                              </div>
                            </v-badge>
                          </v-flex>

                          <v-flex
                            v-for="(item, i) in imageArray"
                            :key="'imgArray'+i"
                            xs4 sm3 md4 lg4
                            px-2 py-2
                          >
                            <v-badge small overlap avatar color="#FF1313">
                              <template v-slot:badge>
                                <v-avatar>
                                  <v-icon small @click="removeImageArray(i)" style="cursor: pointer;">mdi-close</v-icon>
                                </v-avatar>
                              </template>
                              <div style="background: white; border-radius: 6px; border: 1px solid #dde3ea; padding: 4px; display: flex; align-items: center; justify-content: center; height: 60px;">
                                <v-img :src="item" height="44px" width="44px" contain>
                                </v-img>
                              </div>
                            </v-badge>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      
                      <div class="mt-4">
                        <v-btn
                          dark
                          rounded
                          block
                          outlined
                          color="#4CAF50"
                          class="text-capitalize"
                          style="border-radius: 8px; font-family: poppinssemibold; height: 44px;"
                          @click="$refs.files.click()"
                        >
                          <v-icon left>mdi-camera-plus</v-icon>
                          <span style="font-size: 13px">Add Image</span>
                        </v-btn>
                        <input
                          v-show="false"
                          accept="image/*"
                          id="file"
                          ref="files"
                          multiple="multiple"
                          type="file"
                          @change="uploadImages"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </div>

                <!-- Submit (desktop) -->
                <div class="hidden-md-and-down mt-6">
                  <v-btn 
                    block large dark depressed 
                    color="#4CAF50" 
                    class="submit-btn text-capitalize mb-2" 
                    :ripple="false" 
                    :disabled="!valid"
                    @click="validate()">
                    <v-icon left>mdi-check-circle</v-icon>
                    Update Product
                  </v-btn>
                  <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;">Cancel</v-btn>
                </div>

              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCropper from "@/components/Common/imageCropper";
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    ImageCropper,
    VueEditor,
  },
  props: ["productid", "currentPage"],
  data() {
    return {
      deleteImageArrayDialog: false,
      imageArray: [],
      Images: new FormData(),
      formData: new FormData(),
      delFormData: new FormData(),
      selectedFiles: null,
      i: null,
      ServerError: false,
      caption: "",
      comissionPercentage: null,
      deliveryCharge: null,
      description: "",
      file: null,
      image: "",
      tagDialog: false,
      materialDialog: false,
      sizeDialog: false,
      appLoading: false,
      showSnackBar: false,
      productcode: null,
      productname: null,
      productcost: null,
      stockquantity: null,
      mainCategory: [],
      mainCategoryArray: [],
      category: [],
      categoryArray: [],
      subcategoryArray: [],
      subcategory: null,
      msg: null,
      valid: true,
      quantity: "",
      price: "",
      offer: "",
      offerPrice: "",
      specifications: "",
      link: "",
      packingCharge: "",
      tax: "",
      minimumOrderQuantity:"",
      maxOrderQuantity:"",
      deliveryChargeInsideKerala: "",
      deliveryChargeOutsideKerala: "",
      user: {
        stockquantity: null,
        instock: false,
        size: [],
      },
      Rules: [(v) => (v !== null && v !== undefined && String(v).trim() !== '') || "Required"],
      imageCount: 0,
      cropImageDialog: false,
      productTags: [],
      productTag: null,
      currentImage: null,
      seotags: null,
      title: null,
      fbpixel: null,
      keywords: [],
      items: ["meta"],
      keywordItems: ["Best Selling", "User Friendly"],
      NameMsg: null,
    };
  },
  watch: {
    mainCategory() {
      this.getCategory();
    },
    category() {
      this.getSubcategory();
    },
    offer() {
      if (this.offer) {
        this.offerPrice = this.price - (this.price * this.offer) / 100;
      }
    },
    price() {
      if (this.price) {
        this.offerPrice = this.price - (this.price * this.offer) / 100;
      }
    },
  },
  mounted() {
    this.getData();
    this.getMainCategory();
  },
  methods: {
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    collectImages(image) {
      this.selectedFiles = image;
      this.Images.append("image", this.selectedFiles);
      this.formData.append("photos", this.selectedFiles);
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);
        this.imageCount = this.product.photos.length + this.imageArray.length;
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    validate() {
      if (this.$refs.profileForm.validate()) {
        this.editUser();
      }
    },
    getCategory() {
      // this.appLoading = true;
      var data = {};
      data["mainCategoryId"] = this.mainCategory;
      axios({
        url: "/category/getlist",
        method: "POST",
        data: data,
        // params: {
        //   mainCategoryId: this.mainCategory,
        // },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          // this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getMainCategory() {
      this.appLoading = true;
      axios({
        url: "/maincategory/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.mainCategoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubcategory() {
      // this.appLoading = true;
      var data = {};
      data["categoryId"] = this.category;
      axios({
        url: "/subcategory/getlist",
        method: "POST",
        data: data,
        // params: {
        //   categoryId: this.category,
        // },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.subcategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          // this.appLoading = false;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      var data = {};
      data["id"] = this.$route.query.product;
      axios({
        url: "/product/view",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          
          if (this.user.status === 'Updated' && this.user.updatedProducts) {
            const updates = this.user.updatedProducts;
            for (const key in updates) {
              if (updates[key] !== undefined && updates[key] !== null) {
                this.user[key] = updates[key];
              }
            }
          }

          this.productname = this.user.productname;
          this.price = this.user.price;
          this.quantity = this.user.quantity;
          this.offer = this.user.offer;
          this.offerPrice = this.user.offerPrice;
          this.description = this.user.description;
          this.specifications = this.user.specifications;
          this.link = this.user.link;
          this.packingCharge = this.user.packingCharge;
          this.tax = this.user.tax;
          this.maxOrderQuantity=this.user.maxOrderQuantity
          this.minimumOrderQuantity=this.user.minimumOrderQuantity
          this.deliveryChargeInsideKerala = this.user.deliveryChargeInsideKerala;
          this.deliveryChargeOutsideKerala = this.user.deliveryChargeOutsideKerala;
          
          if (this.user.mainCategory && this.user.mainCategory._id) {
            this.mainCategory = this.user.mainCategory._id;
          } else if (this.user.mainCategory) {
            this.mainCategory = this.user.mainCategory;
          }
          if (this.mainCategory) {
            this.getCategory();
          }
          this.category = [];
          if (this.user.category && this.user.category.length > 0) {
            if (typeof this.user.category[0] === 'object') {
              this.category = this.user.category.map((x) => x._id);
            } else {
              this.category = this.user.category;
            }
          }
          // for (var i = 0; i < this.user.category.length; i++) {
          //   this.category.push(this.user.category[i]._id);
          // }
          if (this.category.length > 0) {
            this.getSubcategory();
          }
          this.subcategory = [];
          if (this.user.subcategory && this.user.subcategory.length > 0) {
            if (typeof this.user.subcategory[0] === 'object') {
              this.subcategory = this.user.subcategory.map((x) => x._id);
            } else {
              this.subcategory = this.user.subcategory;
            }
          }
          //   for (var j = 0; j < this.user.subcategory.length; j++) {
          //   this.subcategory.push(this.user.subcategory[j]._id);
          // }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    removePhotos(i) {
      var Data = {};
      this.user.photos.splice(i, 1);
      Data["productid"] = this.$route.query.product;
      Data["sellerid"] = this.user.sellerId._id;
      Data["position"] = i + 1;
      axios({
        method: "POST",
        url: "/Product/RemoveImagesingle",
        data: Data,
        headers: {
          // "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = "Deleted Successfully";
            this.$emit("stepper", {
              editProduct: true,
              getList: true,
            });
            // this.$router.go(-1);
          } else {
            this.msg = "Can't Delete Image";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      console.log(this.formData);
      this.imageArray.splice(i, 1);
      this.deleteImageArrayDialog = false;
    },
    uploadImages(event) {
      if (this.imageCount < 4) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;
        return;
      }
    },
    uploadEditedImages() {
      console.log(this.product);
      this.formData.append("productid", this.$route.query.product);
      this.formData.append("sellerid", this.user.sellerId._id);
      axios({
        method: "POST",
        url: "/Product/UploadImageMultiple",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = "Uploaded Successfully";
            this.$emit("stepper", {
              getList: true,
            });
            // this.$router.go(-1);
            if (this.user.status == "Pending")
              // this.$router.push("/pendingProducts");
              this.$router.go(-1);
            else if (this.user.status == "Active") this.$router.go(-1);
            // this.$router.push("/Products/productView");
          } else {
            this.msg = "Can't Upload Images";
            this.showSnackBar = true;
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editUser() {
      this.appLoading = true;
      var user = {};
      user["productname"] = this.productname;
      user["price"] = this.price;
      user["offer"] = this.offer;
      user["offerPrice"] = this.offerPrice;
      user["subcategory"] = this.subcategory;
      user["category"] = this.category;
      user["mainCategory"] = this.mainCategory;
      user["id"] = this.$route.query.product;
      user["quantity"] = Number(this.quantity);
      user["description"] = this.description;
      user["specifications"] = this.specifications;
      user["link"] = this.link;
      user["packingCharge"] = this.packingCharge;
      user["tax"] = this.tax;
      user["minimumOrderQuantity"] = this.minimumOrderQuantity;
      user["maxOrderQuantity"] = this.maxOrderQuantity;
      user["deliveryChargeInsideKerala"] = Number(this.deliveryChargeInsideKerala);
      user["deliveryChargeOutsideKerala"] = Number(this.deliveryChargeOutsideKerala);
      // if (this.user.stockquantity > 0) this.user.instock = true;
      axios({
        method: "POST",
        url: "/Admin/Product/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            if (this.selectedFiles) this.uploadEditedImages();
            // else
            // this.$router.go(-1);
            else if (this.user.status == "Pending") this.$router.go(-1);
            // this.$router.push("/pendingProducts");
            else if (this.user.status == "Active") this.$router.go(-1);
            // this.$router.push("/Products/productView");
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            // this.$emit("stepper", {
            //   getList: true,
            // });
            // this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
/* ── Page Shell ─────────────────────────────── */
.add-product-page {
  min-height: 100vh;
  background: #f6f8fb;
}

/* ── Page Header ────────────────────────────── */
.page-header {
  background: #ffffff;
  border-bottom: 1px solid #e8ecf0;
  padding: 20px 28px;
  position: sticky;
  top: 0;
  z-index: 2;
}
.page-title-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-title-icon {
  font-size: 28px !important;
  color: #4caf50;
}
.page-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  color: #1c1c1c;
  margin: 0;
  line-height: 1.2;
}

/* ── Form Body ──────────────────────────────── */
.form-body {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}
.form-left-col {
  padding-right: 0;
}
@media (min-width: 1264px) {
  .form-left-col { padding-right: 20px; }
}

/* ── Section Cards ──────────────────────────── */
.form-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.form-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f3f7;
  background: #fafbfc;
}
.section-number {
  font-family: poppinssemibold, sans-serif;
  font-size: 22px;
  color: #d0d8e4;
  line-height: 1;
  min-width: 36px;
}
.section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 15px;
  color: #1c1c1c;
  margin: 0;
}
.section-body { padding: 20px 24px; }

/* ── Fields ─────────────────────────────────── */
.field-group { margin-bottom: 4px; }
.field-label {
  display: block;
  font-family: poppinssemibold, sans-serif;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ── Inputs ─────────────────────────────────── */
.modern-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 40px;
  background: #fdfdfd;
}
.modern-input >>> fieldset { border-color: #dde3ea !important; }
.modern-input:hover >>> fieldset { border-color: #4caf50 !important; }

/* ── Image Panel ────────────────────────────── */
.sticky-panel { position: sticky; top: 85px; }
.image-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  padding: 20px;
}
.image-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.image-section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 14px;
  color: #1c1c1c;
  flex: 1;
}

/* ── Submit Button ──────────────────────────── */
.submit-btn {
  border-radius: 8px !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.5px;
  height: 48px !important;
  background: linear-gradient(135deg, #43a047, #66bb6a) !important;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.35) !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease !important;
}
.submit-btn:hover {
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.45) !important;
  transform: translateY(-1px);
}
.submit-area-mobile { margin-top: 8px; margin-bottom: 24px; }

/* ── Responsive ─────────────────────────────── */
@media (max-width: 960px) {
  .form-body { padding: 16px 12px 40px; }
  .section-header { padding: 14px 16px; }
  .section-body { padding: 14px 16px; }
  .page-header { padding: 14px 16px; }
}
@media (max-width: 600px) {
  .section-number { font-size: 16px; min-width: 28px; }
  .section-title { font-size: 14px; }
}
</style>
